// Simple per-key serialization helper for async persistence calls.
// Ensures that for a given key, async operations are executed in order.
// Memory safety: we remove the key after the chain settles if no new work was
// queued in the meantime (prevents unbounded growth for many unique keys).

const chains = new Map<string, Promise<void>>();

export async function serializeByKey<T>(
  key: string,
  fn: () => Promise<T>
): Promise<T> {
  const previous = chains.get(key) ?? Promise.resolve();

  // Chain the work after the previous finishes (success or failure)
  const next = previous.then(fn, fn);

  // Store a wrapped promise that cleans up the key once it settles.
  // Guard against races by only deleting if our stored reference is still current.
  let stored: Promise<void>;
  stored = next
    .then(
      () => undefined,
      () => undefined
    )
    .finally(() => {
      if (chains.get(key) === stored) {
        chains.delete(key);
      }
    });

  chains.set(key, stored);
  return next;
}
